var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolkswagen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#2f64bf}.cls-2{fill:#254c90}.cls-3{fill:#fff}.cls-4{fill:#3f70c4}.cls-5{fill:#3368c3}.cls-6{fill:#2859ad}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_159",
    "data-name": "Grupo 159",
    transform: "translate(-55.526 -160.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_332",
    d: "M25 0a25 25 0 1 0 25 25A25 25 0 0 0 25 0z",
    className: "cls-1",
    "data-name": "Trazado 332",
    transform: "translate(55.526 160.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_333",
    d: "M11.98 0c-.354 0-.706.009-1.056.024a25 25 0 0 1 0 49.952c.35.015.7.024 1.056.024a25 25 0 1 0 0-50z",
    className: "cls-2",
    "data-name": "Trazado 333",
    transform: "translate(68.545 160.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_334",
    d: "M23.085 44.569a21.482 21.482 0 1 1 21.479-21.482 21.5 21.5 0 0 1-21.479 21.482z",
    className: "cls-3",
    "data-name": "Trazado 334",
    transform: "translate(57.441 162.608)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158",
    transform: "translate(62.459 167.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_335",
    d: "M9.145 4.115a.215.215 0 0 1 .137-.3 18.2 18.2 0 0 1 9.678 0 .215.215 0 0 1 .137.3L14.32 14.7a.215.215 0 0 1-.392 0z",
    className: "cls-4",
    "data-name": "Trazado 335",
    transform: "translate(3.943 -3.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_336",
    d: "M29.221 4.531a18.171 18.171 0 0 1 4.612 4.355.216.216 0 0 1 .023.218l-8.1 17.924a.215.215 0 0 1-.386.013l-2.948-5.507a.215.215 0 0 0-.19-.114H16.4a.215.215 0 0 0-.19.114l-2.948 5.506a.215.215 0 0 1-.386-.013L4.788 9.087a.216.216 0 0 1 .023-.218 18.162 18.162 0 0 1 4.6-4.338.216.216 0 0 1 .313.089l6.489 13.773a.215.215 0 0 0 .195.123h5.839a.215.215 0 0 0 .195-.124L28.909 4.62a.216.216 0 0 1 .312-.089z",
    className: "cls-5",
    "data-name": "Trazado 336",
    transform: "translate(-1.25 -1.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_337",
    d: "M4.03 9.6a.215.215 0 0 0-.406.038 18.1 18.1 0 0 0 8.988 19.954.215.215 0 0 0 .3-.278z",
    className: "cls-6",
    "data-name": "Trazado 337",
    transform: "translate(-3.163 4.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_338",
    d: "M9.126 25.356a18.189 18.189 0 0 0 9.99 0l-4.992-11.084z",
    className: "cls-6",
    "data-name": "Trazado 338",
    transform: "translate(3.943 10.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_339",
    d: "M15.213 29.291a.215.215 0 0 0 .3.279 18.1 18.1 0 0 0 9-19.912.215.215 0 0 0-.406-.039z",
    className: "cls-6",
    "data-name": "Trazado 339",
    transform: "translate(11.174 4.379)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolkswagen);
export default __webpack_public_path__ + "static/media/volkswagen.80972efbd35510c727c61419b89e031b.svg";
export { ForwardRef as ReactComponent };